import React from 'react'
import { Link } from 'react-router-dom'

interface SiteFooterProps {
  logoSrc: string
}

const SiteFooter: React.FC<SiteFooterProps> = ({ logoSrc }) => (
  <footer className="v2-footer">
    <div className="v2-footer__row">
      <div>
        <img alt="Ivy" className="v2-logo" height={40} width={121} src={logoSrc} />
        <p>
          <a href="mailto:support@ivyapp.com">support@ivyapp.com</a>
        </p>
        <p>+1 (773) 369-2127</p>
        <p>Approach Connections LLC, Riverwoods, IL</p>
      </div>

      <div className="v2-footer__links">
        <Link className="v2-footer__legal-link" to="/privacy-policy">
          Privacy Policy
        </Link>
        <Link className="v2-footer__legal-link" to="/terms-of-use">
          Terms of Use
        </Link>
        <a href="#trust">Trust</a>
        <a href="#for-venues">For venues</a>
      </div>
    </div>
  </footer>
)

export default SiteFooter
